import { pad } from './pad.js';
const κ = 903.2962962962963;
const ε = 0.0088564516790356;
const ε_2 = .000005;
const D50 = [0.9642956764295676, 1.00000, 0.8251046025104602];
const M_sRGB = [
    [3.2409699419045226, -1.537383177570094, -0.4986107602930034],
    [-0.9692436362808796, 1.8759675015077202, 0.04155505740717559],
    [0.05563007969699366, -0.20397695888897652, 1.0569715142428786]
];
const D65 = [
    [0.9554734527042182, -0.023098536874261423, 0.0632593086610217],
    [-0.028369706963208136, 1.0099954580058226, 0.021041398966943008],
    [0.012314001688319899, -0.020507696433477912, 1.3303659366080753]
];
const multiplyMatrices = (A, B) => A.map(row => row.reduce((a, v, i) => a + v * (B[i] || 0), 0));
const LCH_to_Lab = (l, c, h) => [
    l,
    c * Math.cos(h * Math.PI / 180),
    c * Math.sin(h * Math.PI / 180) // b
];
const XYZ_to_lin_sRGB = (XYZ) => multiplyMatrices(M_sRGB, XYZ);
const D50_to_D65 = (XYZ) => multiplyMatrices(D65, XYZ);
const Lab_to_XYZ = (l, a, b) => {
    const c = (l + 16) / 116;
    const f_0 = a / 500 + c;
    const f_2 = c - b / 200;
    return [
        (Math.pow(f_0, 3) > ε ? Math.pow(f_0, 3) : (116 * f_0 - 16) / κ) * D50[0],
        (l > κ * ε ? Math.pow((l + 16) / 116, 3) : l / κ) * D50[1],
        (Math.pow(f_2, 3) > ε ? Math.pow(f_2, 3) : (116 * f_2 - 16) / κ) * D50[2]
    ];
};
const gam_sRGB = (RGB) => RGB.map((val) => {
    let sign = val < 0 ? -1 : 1;
    let abs = Math.abs(val);
    if (abs > 0.0031308) {
        return sign * (1.055 * Math.pow(abs, 1 / 2.4) - 0.055);
    }
    return 12.92 * val;
});
const LCH_to_sRGB = (l, c, h) => gam_sRGB(XYZ_to_lin_sRGB(D50_to_D65(Lab_to_XYZ(...LCH_to_Lab(l, c, h)))));
const isLCH_within_sRGB = (l, c, h) => LCH_to_sRGB(l, c, h).reduce((a, b) => a && b >= (0 - ε_2) && b <= (1 + ε_2), true);
const force_into_gamut = (l, c, h) => {
    if (isLCH_within_sRGB(l, c, h)) {
        return [l, c, h];
    }
    let hiC = c;
    let loC = 0;
    const ε = .0001;
    c /= 2;
    while (hiC - loC > ε) {
        if (isLCH_within_sRGB(l, c, h)) {
            loC = c;
        }
        else {
            hiC = c;
        }
        c = (hiC + loC) / 2;
    }
    return [l, c, h];
};
const alpha_to_string = (a = 100) => {
    if (a === 100)
        return '';
    return pad((Math.round(a / 100 * 255)).toString(16), 2);
};
export const lch2rgb = (l, c, h, a = 100, forceInGamut = true) => {
    if (forceInGamut) {
        [l, c, h] = force_into_gamut(l, c, h);
    }
    const rgb = LCH_to_sRGB(l, c, h);

    return "#" + pad(Math.round(rgb[0] * 255).toString(16), 2) +
                 pad(Math.round(rgb[1] * 255).toString(16), 2) +
                 pad(Math.round(rgb[2] * 255).toString(16), 2) + alpha_to_string(a);
};
